//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: "orderconfirm",
  data(){
    return {
      payInfo:{},
      teaminfo:[]
    }
  },
  methods:{
      getPay(){
        this.axios.post('/xcx/Order/buyInfo',{course_id:this.$route.query.id}).then(res=>{
          this.payInfo=res.data.data;
        })
      },
      getTuangouPay(){
        this.axios.post('/xcx/Order/buyTeamInfo',{course_id:this.$route.query.id}).then(res=>{
          this.payInfo=res.data.data;
          this.teaminfo=res.data.data.team_list.slice(0,2);
        })
      },
      payConfirm(){
        let data={
          'course_id':this.$route.query.id,
          'price':this.payInfo.price
        }
        if(this.$route.query.type=='tuangou'){
          data.is_teamer=1;
          data.price=this.payInfo.team_price;
        }
        this.axios.post('/xcx/Order/takeOrder',data).then(res=>{
          this.axios.post('/xcx/Order/recharge',{order_id:res.data.data.order_id,money:res.data.data.money}).then(res2=>{
            this.$wechat.chooseWXPay({
              ...res2.data.data,
              timestamp:res2.data.data.timeStamp,
              success:(payres)=> {
                this.axios.post('/xcx/Order/isSubscribe').then(res3=>{
                  if(res3.data.subscribe){
                    this.$router.replace({name:'success',params:{orderId:res.data.data.order_id,data:this.payInfo}});
                  }else{
                    this.$router.replace({name:'guanzhu'});
                  }
                })
                
              },
              fail:function (err) {
                this.$vux.alert.show({
                  title:'pay error',
                  content:err
                })
              }
            })

          })
        })
        // $router.push({name:$route.query.type=='tuangou'?'groupsuccess':'success'})
      }
  },
  created() {
    if(!this.$route.query.id){
      this.$router.go(-1);
      return
    }
    if(this.$route.query.type=='tuangou'){
      this.getTuangouPay();
    }else{
      this.getPay();
    }

  }
}



// WEBPACK FOOTER //
// ./src/components/orderconfirm/orderconfirm.vue